import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LabelLift from "../UI/LabelLift";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";
import LiftLine from "./components/LiftLine";

const Lift7 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift7"
			 className={getLiftClass(isOpen, activeLiftId === '7', state)}
			 transform="translate(1446.000000, 931.000000)"
		>
			<LiftLine x1="95" y1="146.594075" x2="209.5" y2="280" color={colors[0]}/>
			<LiftLine x1="15.5" y1="17.5" x2="76" y2="116" color={colors[0]}/>

			<LiftLabelTypeSeat
				animationPart={2}
				colors={getLiftStatusColors(state, isOpen)}
				seatCount="4"
				isOpen={isOpen}
				coords="41.000000, 69.000000"/>

			<g id="Labe-lift" className="lift-label">
				<circle fill={colors[1]} fillRule="evenodd" cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" fillRule="evenodd" cx="13" cy="13" r="10"/>
				<text fontFamily="OpenSans-Bold, Open Sans" fontSize="12" fontWeight="normal"/>
			</g>

			<polygon
				fill={colors[2]}
				transform="translate(13.682412, 13.682412) scale(-1, 1) rotate(-59.000000) translate(-13.682412, -13.682412) "
				points="8.18241236 13.6824124 19.1824124 8.18241236 16.8109251 13.6824124 19.1824124 19.1824124"
			/>

			<LabelLift coords="197.000000, 267.000000" isOpen={isOpen} state={state} text="7"/>
		</g>
	);
};

Lift7.propTypes = {};

export default Lift7;
